import api from "@/api";
export default {
    namespaced: true,
    state: {
        buildInfo: {},
        buildList: {},
        buildArtifactList: [],
        buildObjectList: [],
        buildTabList: [],
        activeTab: 'executeInfo',
        buildListPerPage: 10
    },
    mutations: {
        setBuildInfo(state, buildInfo) {
            state.buildInfo = buildInfo
        },
        setBuildList(state, buildList) {
            if (buildList['perPage']) {
                buildList['perPage'] = parseInt(buildList['perPage']);
            }
            state.buildList = buildList;
        },
        setBuildArtifactList(state, buildArtifactList) {
            state.buildArtifactList = buildArtifactList
        },
        setBuildTabList(state, buildTabList) {
            state.buildTabList = buildTabList
        },
        setBuildObjectList(state, buildObjectList) {
            state.buildObjectList = buildObjectList
        },
        setActiveTab(state, tabName) {
            state.activeTab = tabName
        },
        updateBuildInfoStages(state, stages) {
          state.buildInfo.stages = stages
        },
        setBuildAutoTest(state, buildAutoTest) {
            state.buildAutoTest = buildAutoTest
        },
    },
    actions: {
        async loadBuildInfo({ commit }, buildId) {
            let buildInfo = await api.build.loadBuildInfo(buildId);
            if (buildInfo) {
                commit('setBuildInfo', buildInfo);
            }
        },
        async loadBuildList({ commit }, [pipelineId, page, pageSize]) {
            let buildList = await api.build.loadBuildList(pipelineId, page, pageSize);
            if (buildList) {
                commit('setBuildList', buildList);
            }
        },
        async loadBuildArtifactList({ commit }, buildId) {
            let buildArtifactList = await api.build.loadBuildArtifactList(buildId);
            if (buildArtifactList) {
                commit('setBuildArtifactList', buildArtifactList);
            }
        },
        async loadBuildTabList({ commit }, [objectId, objectType, currentPage, pageSize]) {
            let buildTabList = await api.build.loadBuildTabList(objectId, objectType, currentPage, pageSize);
            if (buildTabList) {
                commit('setBuildTabList', buildTabList);
            }
        },
        async loadBuildObjectList({ commit }, [buildId, page, pageSize]) {
            let buildObjectList = await api.build.loadBuildObjectList(buildId, page, pageSize);
            if (buildObjectList) {
                commit('setBuildObjectList', buildObjectList);
            }
        },
        async loadBuildAutoTest({ commit }, buildId) {
            let buildAutoTest = await api.build.loadBuildAutoTest(buildId);
            if (buildAutoTest) {
                commit('setBuildAutoTest', buildAutoTest);
            }
        },
        setActiveTabAction({ commit }, tabName) {
            commit('setActiveTab', tabName);
        },
        updateBuildInfoStages({ commit }, stages) {
          commit('updateBuildInfoStages', stages);
        },
        clearBuildInfo({ commit }) {
            commit('setBuildInfo', {});
        },
    }
}